export default customElements.define('w-grid-item', class GridItem extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'o-grid-item';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `<div class="${styleSelector}__container" data-root></div>`,
            hasChildren: true
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validSpans () {
        return [ 'auto', 'fit-content', '10', '20', '25', '33', '40', '50', '60', '66', '80', '100' ];
    }

    static get observedProps() {
        return [
            new wealthify.Prop('spanmobile', {type: wealthify.propTypes.ArrayItem(this.validSpans)}),
            new wealthify.Prop('spantablet', {type: wealthify.propTypes.ArrayItem(this.validSpans)}),
            new wealthify.Prop('spantabletwide', {type: wealthify.propTypes.ArrayItem(this.validSpans)}),
            new wealthify.Prop('spandesktop', {type: wealthify.propTypes.ArrayItem(this.validSpans)}),
            new wealthify.Prop('spanwide', {type: wealthify.propTypes.ArrayItem(this.validSpans)}),
            wealthify.props.Order({name: 'ordermobile'}),
            wealthify.props.Order({name: 'ordertablet'}),
            wealthify.props.Order({name: 'ordertabletwide'}),
            wealthify.props.Order({name: 'orderdesktop'}),
            wealthify.props.Order({name: 'orderwide'}),
        ];
    }

    get propCallbacks() {
        return {
            spandesktop: () => this._toggleSpanModifier('spandesktop'),
            spanmobile: () => this._toggleSpanModifier('spanmobile'),
            spantablet: () => this._toggleSpanModifier('spantablet'),
            spantabletwide: () => this._toggleSpanModifier('spantabletwide'),
            spanwide: () => this._toggleSpanModifier('spanwide'),
        };
    }

    _toggleSpanModifier (prop) {      

        this.constructor.validSpans.forEach((type) => {
            this.classList.remove(`${this.styleSelector}--${prop}-${type}`);
        });

        if (!this[prop]) {
            return;
        }
       
        this.classList.add(`${this.styleSelector}--${prop}-${this[prop]}`);
    }

});